<template>
  <fieldset class="flex flex-col gap-spacing_3">
    <div class="flex flex-col gap-spacing_9" :class="radioContainerClass">
      <Radio
        v-for="option in options"
        v-model="value"
        v-bind="option"
        :name
        :right-aligned
        :key="option.value"
        :disabled="option.disabled || disabled"
        @update:model-value="onChange"
      >
        <template v-if="$slots.suffix" #suffix>
          <slot name="suffix" :option="option" />
        </template>
      </Radio>
    </div>

    <CommonMessage
      v-if="errorMessage"
      prefix_icon="ic-info"
      :error="!!errorMessage"
      :message="errorMessage"
    />
  </fieldset>
</template>

<script setup lang="ts">
import type { RadioGroupProps } from "~/types/schemas/common/Atom/radio";
import VALID_SCHEMA from "~/constants/ValidationSchema";
import { useField } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import CommonMessage from "~/components/common/Atom/Message.vue";
import Radio from "~/components/common/Atom/Radio.vue";

const props = withDefaults(
  defineProps<
    RadioGroupProps & {
      radioContainerClass?: string;
    }
  >(),
  {
    validation: "DEFAULT",
  },
);

const emit = defineEmits<{
  change: [value: string | number];
}>();

const { value, errorMessage, handleChange } = useField<string | number>(
  () => props.name,
  toTypedSchema(VALID_SCHEMA?.[props.validation]),
  {
    initialValue: props.initialValue ?? undefined,
    type: "radio",
  },
);

const onChange = (value?: string | number) => {
  if (value) {
    handleChange(value);
    emit("change", value);
  }
};
</script>
